import { IoClose } from 'react-icons/io5';
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Spinner } from '@ds';
import { ReactNode } from 'react';

export type ConfirmReservationModalProps = {
  title: string;
  description: ReactNode;
  isOpen: boolean;
  isLoading: boolean;
  onSelect: () => void;
  onClose: () => void;
};

export const ConfirmReservationModal = ({
  title,
  description,
  isOpen,
  isLoading,
  onSelect,
  onClose,
}: ConfirmReservationModalProps) => {
  const modalSize = 'lg';

  const onConfirmReservation = () => {
    onSelect();
  };

  return (
    <Modal
      size={modalSize}
      isOpen={isOpen}
      onClose={onClose}
      backdrop="opaque"
      closeButton={<IoClose size={45} style={{ top: 15 }} />}
      classNames={{
        base: 'px-6',
        body: 'border-y-1 border-base-30 px-0 py-6 text-l-r',
        header: 'px-0 font-secondary text-hl! text-base-20',
        footer: 'px-0 flex gap-6',
        wrapper: 'z-420',
        backdrop: 'z-419',
      }}
    >
      <ModalContent>
        {() => (
          <>
            {isLoading && (
              <div className="absolute top-0 left-0 flex justify-center items-center z-50 w-full h-full bg-white bg-opacity-40">
                <Spinner size="md" />
              </div>
            )}
            <ModalHeader>{title}</ModalHeader>
            <ModalBody>{description}</ModalBody>
            <ModalFooter>
              <Button size="md" variant="outline" onClick={onClose}>
                Discard
              </Button>
              <Button isDisabled={isLoading} size="md" color="default" variant="solid" onClick={onConfirmReservation}>
                Confirm
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
